import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Chip,
  Box,
  CircularProgress
} from '@mui/material';

const getStatusChip = (status) => {
  if (status === 'approved') {
    return <Chip label="Goedgekeurd" color="success" size="small" />;
  }
  if (status === 'rejected') {
    return <Chip label="Afgekeurd" color="error" size="small" />;
  }
  return <Chip label={status} size="small" />;
}

function SuggestionsTable({
  suggestions,
  isLoading,
  role,
  onApprove,
  onReject,
  showStatus = false
}) {
  const tableCols = showStatus ? 7 : 6;

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <TableContainer component={Paper} sx={{ mt: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Originele Stofnaam</TableCell>
            <TableCell>Gesuggereerde Parameter</TableCell>
            <TableCell>Reden</TableCell>
            <TableCell>Ingediend door</TableCell>
            <TableCell>Datum</TableCell>
            {showStatus && <TableCell>Status</TableCell>}
            {role === 'admin' && !showStatus && <TableCell align="center">Acties</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {suggestions.map((s) => (
            <TableRow key={s.id}>
              <TableCell>{s.original_stof_value}</TableCell>
              <TableCell>{s.suggested_parameter?.description}</TableCell>
              <TableCell>{s.reason}</TableCell>
              <TableCell>{s.author?.full_name}</TableCell>
              <TableCell>{new Date(s.created_at).toLocaleDateString()}</TableCell>
              {showStatus && <TableCell>{getStatusChip(s.status)}</TableCell>}
              {role === 'admin' && !showStatus && onApprove && onReject && (
                <TableCell align="center">
                  <Box sx={{ display: 'flex', gap: 1, justifyContent: 'center' }}>
                    <Button variant="contained" color="success" size="small" onClick={() => onApprove(s.id)}>
                      Goedkeuren
                    </Button>
                    <Button variant="contained" color="error" size="small" onClick={() => onReject(s.id)}>
                      Afkeuren
                    </Button>
                  </Box>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default SuggestionsTable; 